import { Notify } from 'quasar'

Notify.setDefaults({
  position: 'right',
  timeout: 2500,
  textColor: 'white'
})
